<template>
  <div class="invoice-container">
    <div class="title-info">
      <div class="title-button">
        <div class="title-number">
          <h3 class="title">Nota Fiscal:&nbsp;</h3>
          <h3 class="invoice-number">{{ invoice.invoiceNumber }}</h3>
        </div>
        <button
          @click="areItemsVisible = !areItemsVisible"
          :class="[areItemsVisible ? 'is-up' : 'is-down']"
        >
          &#9002;
        </button>
      </div>
      <Item
        class="item"
        v-show="areItemsVisible"
        v-for="item in invoice.items"
        :key="item.id"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import Item from "@/components/home/return-tracking/ItemReturnTracking.vue";

export default {
  name: "InvoiceReturnTracking",
  components: {
    Item
  },
  props: ["invoice"],
  data() {
    return {
      areItemsVisible: false,
      itemList: [1, 2, 3, 4]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.invoice-container {
  background-color: $grey5;
  width: 90%;
  height: 90%;
  padding: 10px;
  margin: 20px;
  display: flex;
  justify-content: center;
  min-width: 600px;
  align-items: center;

  .title-info {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .title-button {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .title-number {
        display: flex;
        width: 80%;
        border-bottom: 1px solid #c8c8c8;
        padding-bottom: 5px;
        height: 43px;

        .title {
          padding-left: 15px;
          font-weight: 300;
          color: $grey1;
          font-weight: 500;
          align-self: flex-start;
        }

        .invoice-number {
          color: $grey1;
        }
      }

      button {
        color: $grey1;
        width: 25px;
        height: 25px;
        outline: none;
        text-align: center;
        background: none;
        border: none;
        font-size: 18px;
        line-height: 25px;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.is-up {
  transform: rotate(270deg);
}

.is-down {
  transform: rotate(90deg);
}
</style>
